export default __webpack_public_path__ + "static/media/bitcoin.e146d46f.png";